import { useEffect, useCallback, useState} from 'react';

export function formatTimeAgoShort(date) {
    const then = typeof date === 'string' || typeof date === 'number' ? new Date(date).getTime() : +date;
    const now = Date.now();
    let diff = Math.max(0, Math.floor((now - then) / 1000));
    
    const units = [
        ['m', 31536000],
        ['mėn', 2592000],
        ['sav', 604800],
        ['d.', 86400],
        ['val.', 3600],
        ['min', 60],
        ['s', 1]
    ];

    for (const [label, secs] of units) {
        const val = Math.floor(diff / secs);
        if (val >= 1) return `prieš ${val} ${label}`;
    }
    return 'dabar';
}

export function useTimeAgo(date) {
    const get = useCallback(() => formatTimeAgoShort(date), [date]);
    const [text, setText] = useState(get);

    useEffect(() => {
        const now = Date.now();
        const then = new Date(date).getTime();
        const secDiff = Math.abs(Math.floor((now - then) / 1000));
        const intervalMs = secDiff < 60 ? 100 : secDiff < 3600 ? 60_000 : 3_600_000;

        const id = setInterval(() => setText(get()), intervalMs);
        return () => clearInterval(id);
    }, [date, get]);

    return text;
};